export default __webpack_public_path__ + "static/media/Philip_Fruytiers_-_St._Francis_of_Assisi.3b5ee9d2.jpg";